import React from "react";
import { Box, useTheme, Typography, Button } from "@material-ui/core";
import ProductDetailsModule from "./Module";
import LocalizedLink from "../../../../../components/localized-link";
import useTranslate from "../../../../../hooks/use-translate";
import { formatMultilinesText } from "../../../../../helpers/markdown";
import { getBrandPagePath } from "../../../../../helpers/url";
import Imgix from "react-imgix";
import OpenInNew from "@material-ui/icons/OpenInNew";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

type Props = {
  data: {
    title: string;
    brand: Queries.ProductDetailsPageDataQuery["datoCmsProduct"]["variants"][number]["brand"];
  };
};

const ProductDetailsModuleBrandProfile = ({ data }: Props) => {
  const theme = useTheme();
  const t = useTranslate();
  return (
    <ProductDetailsModule title={data.title}>
      <Box display="flex" flexDirection="column" alignItems="stretch">
        <Box display="flex" marginBottom={{ xs: 2, md: 3 }}>
          {data.brand?.image?.url && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              marginRight={4}
            >
              <LocalizedLink to={getBrandPagePath(data.brand.slug)}>
                <Imgix
                  src={data.brand.image.url}
                  width={theme.spacing(12)}
                  height={theme.spacing(12)}
                  htmlAttributes={{
                    title: data.brand.name,
                    alt: data.brand.name,
                    loading: "lazy"
                  }}
                  imgixParams={{
                    ar: "1",
                    fit: "fill",
                    auto: "format,compress"
                  }}
                />
              </LocalizedLink>
            </Box>
          )}
          <Box flex={1} display="flex" flexDirection="column">
            {data.brand.name && <Typography>{data.brand.name}</Typography>}
            {data.brand.region && (
              <Typography color="textSecondary">{data.brand.region}</Typography>
            )}
            <Box marginTop={0}>
              <Button
                component={LocalizedLink}
                variant="text"
                endIcon={<ArrowForwardIcon />}
                size="small"
                to={getBrandPagePath(data.brand.slug)}
                style={{
                  marginLeft: theme.spacing(-1),
                  paddingLeft: theme.spacing(1.5),
                  paddingRight: theme.spacing(1.5),
                  marginTop: theme.spacing(0.5)
                }}
              >
                {t("pdp.brandProfile.allProducts")}
              </Button>
            </Box>
            {data.brand.region &&
              data.brand.website &&
              !data.brand.website.includes("airgraft.com") && (
                <Box marginTop={0}>
                  <Button
                    component={LocalizedLink}
                    variant="text"
                    endIcon={<OpenInNew />}
                    size="small"
                    to={data.brand.website}
                    style={{
                      marginLeft: theme.spacing(-1),
                      paddingLeft: theme.spacing(1.5),
                      paddingRight: theme.spacing(1.5),
                      marginTop: theme.spacing(0.1)
                    }}
                  >
                    {t("pdp.brandProfile.website")}
                  </Button>
                </Box>
              )}
          </Box>
        </Box>
      </Box>
      {data.brand.description && (
        <Typography
          dangerouslySetInnerHTML={{
            __html: formatMultilinesText(data.brand.description)
          }}
        />
      )}
    </ProductDetailsModule>
  );
};

export default ProductDetailsModuleBrandProfile;
